export default __webpack_public_path__ + "static/media/bloodbath4.939f427a.png";